import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/api.service';
import { COLORS } from '../config/constants';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [token, setToken] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const tokenParam = searchParams.get('token');
    if (!tokenParam) {
      setMessage({ type: 'error', text: 'Geçersiz sıfırlama linki' });
    } else {
      setToken(tokenParam);
    }
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!password || !confirmPassword) {
      setMessage({ type: 'error', text: 'Lütfen tüm alanları doldurun' });
      return;
    }

    if (password.length < 6) {
      setMessage({ type: 'error', text: 'Şifre en az 6 karakter olmalıdır' });
      return;
    }

    if (password !== confirmPassword) {
      setMessage({ type: 'error', text: 'Şifreler eşleşmiyor' });
      return;
    }

    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      await authService.resetPassword(token, password);
      setMessage({ 
        type: 'success', 
        text: 'Şifreniz başarıyla güncellendi! Giriş sayfasına yönlendiriliyorsunuz...' 
      });
      
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.detail || 'Bir hata oluştu. Link geçersiz veya süresi dolmuş olabilir.' 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <div style={{
        background: '#FFFFFF',
        borderRadius: '20px',
        padding: '3rem',
        maxWidth: '450px',
        width: '100%',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h1 style={{ 
            color: COLORS.primary, 
            fontSize: '2rem', 
            marginBottom: '0.5rem',
            fontWeight: '700'
          }}>
            🔑 Yeni Şifre Belirle
          </h1>
          <p style={{ color: '#666', fontSize: '0.95rem' }}>
            Hesabınız için yeni bir şifre oluşturun.
          </p>
        </div>

        {message.text && (
          <div style={{
            padding: '1rem',
            borderRadius: '10px',
            marginBottom: '1.5rem',
            background: message.type === 'success' ? '#d1fae5' : '#fee2e2',
            color: message.type === 'success' ? '#065f46' : '#991b1b',
            fontSize: '0.9rem'
          }}>
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '0.5rem', 
              fontWeight: '600',
              color: '#333'
            }}>
              Yeni Şifre
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="En az 6 karakter"
              required
              minLength={6}
              style={{
                width: '100%',
                padding: '0.875rem',
                border: '2px solid #E8E8E8',
                borderRadius: '10px',
                fontSize: '1rem',
                transition: 'border 0.3s'
              }}
              onFocus={(e) => e.target.style.borderColor = COLORS.primary}
              onBlur={(e) => e.target.style.borderColor = '#E8E8E8'}
            />
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '0.5rem', 
              fontWeight: '600',
              color: '#333'
            }}>
              Şifre Tekrar
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Şifreyi tekrar girin"
              required
              minLength={6}
              style={{
                width: '100%',
                padding: '0.875rem',
                border: '2px solid #E8E8E8',
                borderRadius: '10px',
                fontSize: '1rem',
                transition: 'border 0.3s'
              }}
              onFocus={(e) => e.target.style.borderColor = COLORS.primary}
              onBlur={(e) => e.target.style.borderColor = '#E8E8E8'}
            />
          </div>

          <button
            type="submit"
            disabled={loading || !token}
            style={{
              width: '100%',
              padding: '1rem',
              background: (loading || !token) ? '#CCC' : `linear-gradient(135deg, ${COLORS.primary} 0%, #B00803 100%)`,
              color: '#FFFFFF',
              border: 'none',
              borderRadius: '10px',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: (loading || !token) ? 'not-allowed' : 'pointer',
              marginBottom: '1rem',
              transition: 'transform 0.2s',
              boxShadow: '0 4px 12px rgba(228, 10, 4, 0.3)'
            }}
            onMouseOver={(e) => !loading && token && (e.target.style.transform = 'translateY(-2px)')}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            {loading ? '🔄 Güncelleniyor...' : '✅ Şifreyi Güncelle'}
          </button>

          <button
            type="button"
            onClick={() => navigate('/login')}
            style={{
              width: '100%',
              padding: '0.875rem',
              background: '#FFFFFF',
              color: COLORS.primary,
              border: `2px solid ${COLORS.primary}`,
              borderRadius: '10px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s'
            }}
            onMouseOver={(e) => {
              e.target.style.background = COLORS.primary;
              e.target.style.color = '#FFFFFF';
            }}
            onMouseOut={(e) => {
              e.target.style.background = '#FFFFFF';
              e.target.style.color = COLORS.primary;
            }}
          >
            ← Giriş Sayfasına Dön
          </button>
        </form>

        <div style={{
          marginTop: '2rem',
          padding: '1rem',
          background: '#F3F4F6',
          borderRadius: '10px',
          fontSize: '0.875rem',
          color: '#666',
          textAlign: 'center'
        }}>
          💡 Güçlü bir şifre seçin: Büyük/küçük harf, rakam ve özel karakter kullanın.
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
